import { gql } from '@apollo/client';

export const GET_ACTIVE_LISTINGS_PUBLICATION_DISTRIBUTION_PER_PUBLICATION_DATE = gql`
  query GetActiveListingsPublicationDistributionPerPublicationDate($vendorNames: [String!]!) {
    getActiveListingsPublicationDistributionPerPublicationDate(vendorNames: $vendorNames) {
      publicationDateWeekRangeISO8601
      amountOfListingsPerPeriod
      averageSuggestedPricePercentage
    }
  }
`;
